.thumb {
    width: 100%;
    height: 200px;
    padding: 20px;
    margin-bottom: 10px;
    background-color: white;
    border-radius: 10px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
    border: 1px solid #e0e0e0;
    
    &:hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        border-color: #0066FF;
    }
}

.overview {
    font-size: 14px;
    font-family: Hanken Grotesk;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.title {
    font-size: 18px;
    font-family: Hanken Grotesk;
    font-weight: 600;
    margin-bottom: 4px;
}

.industry {
    font-size: 14px;
    font-family: Hanken Grotesk;
    color: #666;
    padding-bottom: 8px;
}

.divider {
    width: 100%;
    height: 1px;
    background-color: #e0e0e0;
    margin-bottom: 12px;
} 